import { ClientDetailResponse } from "@/api";
import { FormDialog } from "@/common/components/form-dialog/FormDialog";
import { useTranslation } from "@/translations";

import { AmbulanzFormFields } from "../shared/AmbulanzFormFields";
import { useAmbulanzCreation } from "./hooks/useAmbulanzCreation";

interface Props {
  onClose: () => void;
  client?: ClientDetailResponse;
}

export function AmbulanzCreationDialog({ onClose, client }: Props) {
  const { t } = useTranslation();
  const { formik, typeOptions, submitDisabled } = useAmbulanzCreation(onClose, client);

  return (
    <FormDialog
      title={t("ambulanzes.creationDialog.title")}
      onClose={onClose}
      formik={formik}
      submitLabel={t("ambulanzes.creationDialog.submitButton")}
      submitDisabled={submitDisabled}
      fullWidth
    >
      <AmbulanzFormFields
        formik={formik}
        typeOptions={typeOptions}
        clientReadOnly={!!client}
        clientName={client && `${client.lastName}, ${client.firstName}`}
        focusAmbulanzNumber={!!client}
      />
    </FormDialog>
  );
}
